import {Component, Input, OnChanges, AfterContentInit, OnInit, Inject, PLATFORM_ID, OnDestroy, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {LocalStorageManager} from 'src/app/data/manager/local-storage/local-storage.manager';
import {isPlatformBrowser} from '@angular/common';
import {countryConfig} from 'src/country-config/country-config';
import {CartRes} from '../../../../../data/networking/models/cart/responses/cart-res';
import {ResizeEvent} from '../../../event-listeners/resize/resize.event';
import {HeaderDepartmentsService} from '../../../utilities/header-departments-service/header-departments.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ProductInterface } from 'src/app/data/networking/models/shared/responses/product-response';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit, AfterContentInit, OnChanges, OnDestroy {
  @Input() cart: CartRes;
  @Input() sasCart;
  @Input() enableSas;
  @Input() color;
  @Input() icon;
 
  countryConfig = countryConfig;
  quantitySummary: number = 0;
  isBrowser;
  screenSize;
  cartIcon: string;
  eventsRouter;
  bolivarDigital = this.countryConfig.bolivarDigital;
  setHEaderSubscriber: Subscription;
  setHeaderStyle;
  gender;
  configStylesHeader;
  activeCustom =false;
  providerList: ProductInterface[] = [];


  get getService() {
    return countryConfig.getService;
  }
  public christmas: boolean = countryConfig.christmas;

  constructor(
    @Inject(PLATFORM_ID) platformId,
    private resizeEvent: ResizeEvent,
    private _headerDepartmentsService: HeaderDepartmentsService,
    private router: Router,
    private lsm: LocalStorageManager,
    private store: Store<AppState>
  ) {   
    let customer = this.lsm.get('customer');
    this.gender = customer?.gender;
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);

    if (this.isBrowser) {
      this.screenSize = {
        mobile: window.screen.width < 992,
        desktop: window.screen.width >= 992,
      };
    }
    if (this.isBrowser && this.screenSize?.mobile) {
      this.setHEaderSubscriber = this.store.select( 'setHeader' ).subscribe( (data:any)=>{
        this.setHeaderStyle = data;
        this.cartIconData(data,'./assets/svg/carrito-blue.svg' );
      });
    } else {
      this.setHEaderSubscriber = this.store.select( 'setHeader' ).subscribe( (data:any)=>{
        this.setHeaderStyle = data;
        this.cartIconData(data, './assets/svg/carrito.svg' );
      });
    }
  }

  ngOnDestroy(): void {
  }

  getQuantitySummary(): void {
    this.quantitySummary = 0;
    const productsProvider = this.cart?.providerList ? [
      ...this.cart?.providerList[0]?.itemList || [],
      ...this.cart?.providerList[1]?.itemList || []
    ] : [];
    productsProvider && (this.providerList = productsProvider);
    if (this.providerList?.length > 0) {
      this.quantitySummary += this.cart?.providerList
        .reduce((accumulator, currentValue) => accumulator + currentValue?.quantityItem, 0);
    }

    if (this.cart?.itemList?.length > 0) {
      this.quantitySummary += this.cart?.itemList
        .reduce((accumulator, currentValue) => accumulator + currentValue?.quantitySold, 0);
    }
  }

  ngOnInit() {
    this.getQuantitySummary();
    this._headerDepartmentsService.getColor().subscribe(res => {
      this.setHEaderSubscriber = this.store.select( 'setHeader' ).subscribe( (data:any)=>{
        if (res.headerColor !== '#fff') {
          this.cartIconData(data, './assets/svg/carrito-white.svg');
        } else {
          this.cartIcon = './assets/svg/carrito-blue.svg';
          this.setHeaderStyle = data?.data;
          this.cartIconData(data, './assets/svg/carrito-blue.svg');
        }
      });
    });
    this._headerDepartmentsService.getCartIcon().subscribe(res => {
      this.cartIcon = res.icon;
    });
  }

  cartIconData(data, icon){
    if(data?.dataCustom?.activeMen || data?.dataCustom?.activeWome){
      if(this.gender === 'M' &&  data?.dataCustom?.activeMen){
        this.activeCustom = data?.dataCustom?.activeMen;
        this.cartIcon = data?.dataCustom?.configMen?.header_cart_icon;
        this.configStylesHeader= data?.dataCustom?.configMen;
      }else if(this.gender === 'F' &&  data?.dataCustom?.activeWomen){
        this.activeCustom = data?.dataCustom?.activeMen;
        this.cartIcon = data?.dataCustom?.configWomen?.header_cart_icon;
        this.configStylesHeader= data?.dataCustom?.configMen;
      }else {
        this.cartIcon = (data?.data?.active && data?.data?.config?.header_cart_icon) ? data?.data?.config?.header_cart_icon : icon;
        this.configStylesHeader= data?.data?.active? data?.data?.config: null
      }
    }
    else {
      this.cartIcon = (data?.data?.active && data?.data?.config?.header_cart_icon) ? data?.data?.config?.header_cart_icon : icon;
      this.configStylesHeader=data?.data?.active ? data?.data?.config : null;
    }
  }
  ngAfterContentInit(): void {
    this.resizeEvent.currentScreenSize.subscribe(s => {
      if (s) {
        this.isBrowser = s.mobile;
        this.screenSize = {
          mobile: s.mobile,
          desktop: false,
        };
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.icon?.currentValue){
      this.cartIcon = changes?.icon?.currentValue;
    }
    if(changes?.cart){
      this.getQuantitySummary();
    }
  }

  gotoCart() {
    this.lsm.set('mobileSaG', false);
    this.router.navigate(['/carrito'])
  }
}
